<section class="table-wrapper">
    <table class="table">
        <thead class="table-head">
                <tr class="th-row">
                    <th class="th-data">
                        <div (click)="toggling('loanId')" class="title-group pointer">
                            <span>Loan ID</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <th class="th-data">
                        <div (click)="toggling('productType')" class="title-group pointer">
                            <span>Product Type</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <th class="th-data">
                        <div (click)="toggling('investmentDate')" class="title-group pointer">
                            <span>Investment Date</span>
                            <div class="sort-group">
                                <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                                <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                            </div>
                        </div>
                    </th>
                    <th class="th-data">
                        <div class="title-group">
                            <span>Borrower Details</span>
                        </div>
                    </th>
                    <th class="th-data">
                        <div class="title-group">
                            <span>Loan Agreement</span>
                        </div>
                    </th>
                    <th class="th-data">
                        <div class="title-group">
                            <span>Loan Reversal</span>
                        </div>
                    </th>
                </tr>
        </thead>
        <tbody class="table-body">
            <tr class="tb-row" *ngFor="let loan of loans">
                <td class="tb-data">{{loan.loanShortId}}</td>
                <td class="tb-data">{{loan.productCode}}</td>
                <td class="tb-data">{{loan.investmentTime | dateFormat}}</td>
                <td class="tb-data">
                    <span class="hard-text blue" (click)="onClickBorrowersDetail(loan)">
                        Borrower Details
                    </span>
                </td>
                <td class="tb-data">
                    <span class="hard-text blue" (click)="onDownloadLoanAgreement(loan)">
                        Loan Agreement
                    </span>
                </td>
                <td class="tb-data">
                    <span *ngIf="loan.isLoanReversible" class="hard-text red" (click)="onClickLoanReverse(loan)">
                        Reverse the Loan
                    </span>
                    <span *ngIf="!loan.isLoanReversible" class="hard-text">
                        —
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</section>

<!-- MOBILE SCREEN PORTION STARTS -->
<article class="responsive-table">
    <mat-accordion>
        <section class="header-table">
            <div class="header-cell col-min-width loanId-col-width">
                <div (click)="toggling('loanId')" class="title-group pointer">
                    <span>Loan ID</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </div>
            <div class="header-cell col-min-width product-col-min">
                <div (click)="toggling('productType')" class="title-group pointer">
                    <span>Product Type</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </div>
            <div class="header-cell">
                <div (click)="toggling('investmentDate')" class="title-group invest-max-width pointer">
                    <span>Investment Date</span>
                    <div class="sort-group">
                        <mat-icon class="sorting-icons">arrow_drop_up</mat-icon>
                        <mat-icon class="sorting-icons">arrow_drop_down</mat-icon>
                    </div>
                </div>
            </div>
        </section>
        <section class="body-table">
            <mat-expansion-panel *ngFor="let loan of loans;" class="expansion-panel">
                <mat-expansion-panel-header class="expansion-panel-header">
                    <div class="body-cell loanId-margin col-min-width">
                        <div class="data-text">
                            <span>{{loan.loanShortId}}</span>
                        </div>
                    </div>
                    <div class="body-cell product-margin col-min-width">
                        <div class="data-text">
                            <span>{{loan.productCode}}</span>
                        </div>
                    </div>
                    <div class="body-cell">
                        <div class="data-text">
                            <span>{{loan.investmentTime | date:'dd MMM yyyy'}}</span>
                        </div>
                    </div>
                </mat-expansion-panel-header>
                <mat-panel-description class="description-panel">
                    <span class="hard-text blue" (click)="onClickBorrowersDetail(loan)">
                        Borrower Details
                    </span>
                    <span class="hard-text blue" (click)="onDownloadLoanAgreement(loan.loanId)">
                        Loan Agreement
                    </span>
                    <span  *ngIf="loan.isLoanReversible" class="hard-text red" (click)="onClickLoanReverse(loan)">
                        Reverse the Loan
                    </span>
                    <span  *ngIf="!loan.isLoanReversible" class="hard-text">
                        —
                    </span>
                </mat-panel-description>
            </mat-expansion-panel>
        </section>
    </mat-accordion>
</article>
